import { CUSTOM_FIELDS } from "../entity_crud/FieldType";
import { GraphqlUtilsTad } from "./GraphqlUtilsTad";

/**
 * Generated with AI.
 * @see GraphqlUtilsTad.tsx 
 */
export function getEntityGraphFields(fieldsString: string): string[] {
    const tokens = fieldsString.match(/\w+\s*(?:\([^)]*\))?|\{|\}/g) || []; // tokenize: words, braces, and argument blocks
    let index = 0;

    function walk(parentPath: string[] = []): string[] {
        const result: string[] = [];
        while (index < tokens.length) {
            const token = tokens[index++];
            if (token === "}") {
                break;
            } else if (token === "{") {
                continue;
            } else {
                const field = token.trim();
                // skip customFields
                if (field.startsWith(`${CUSTOM_FIELDS}(`)) {
                    continue;
                }
                if (tokens[index] === "{") {
                    index++;
                    result.push(...walk([...parentPath, field]));
                } else {
                    const path = [...parentPath, field].join(".");
                    result.push(path);
                }
            }
        }
        return result;
    }
    return walk();
}